import { Grid } from "@material-ui/core";
import BillCustomTable from "./BillCustomTable";
import { returnJalali } from "../../utils/TimeUtils";
const BillBody = ({ info, type }) => {
  const durationData = [
    "",
    returnJalali(info.bill_start_date),
    returnJalali(info.bill_end_date),
  ];
  const counterData = [info.bill_water_meter.water_meter_serial, "فعال"];
  const consumptionData = [
    info.other_information.period_days,
    info.consumptions.toLocaleString(undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }),
    (info.consumptions / info.other_information.period_days).toFixed(2),
  ];
  const consumptionDetails = [
    info?.other_information?.start_period_sum
      ? info?.other_information?.start_period_sum.toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      : info?.other_information?.start_period_sum,
    info?.other_information?.end_period_sum
      ? info?.other_information?.end_period_sum.toLocaleString(undefined, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      : info?.other_information?.end_period_sum,
    info?.other_information?.bill_factor
      ? info?.other_information?.bill_factor
      : // ? 1
        1,
  ];
  const price = [
    "بهای میزان مصرف",
    Math.round(info.bill_price).toLocaleString(),
  ];
  const services = ["بهای خدمات", ""];
  const taxes = ["آبونمان", ""];
  const totalPrice = [
    "جمع صورتحساب دوره",
    Math.round(info.bill_price).toLocaleString(),
  ];
  return (
    <>
      <Grid container xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={4} sm={4} md={4} lg={4}>
          <BillCustomTable
            header={["دوره"]}
            body={[["نام دوره", "از تاریخ", "تا تاریخ"], durationData]}
            hcolspan={"3"}
            type={type}
          />
          <BillCustomTable
            header={["سریال کنتور", "وضعیت کنتور"]}
            body={[counterData]}
            hcolspan={"1"}
            type={type}
          />
          <BillCustomTable
            className="extra-bill-section"
            header={["شرح مصرف کنتور"]}
            body={[["قرائت پیشین", "قرائت فعلی", "ضریب"], consumptionDetails]}
            hcolspan={"3"}
            type={type}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4}>
          <div
            style={{
              margin: "0 6px",
              border: "1px solid #000",
              height: "calc(100% - 11px)",
            }}
          ></div>
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4}>
          <BillCustomTable
            header={["مصرف"]}
            body={[
              ["طول دوره (روز)", "مصرف دوره", "میانگین مصرف"],
              consumptionData,
            ]}
            hcolspan={"3"}
            type={type}
          />
          <BillCustomTable
            header={["شرح", "مبلغ (ریال)"]}
            body={[price, services, taxes, totalPrice]}
            hcolspan={"1"}
            type={type}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default BillBody;
